import { render, staticRenderFns } from "./PromotionReportList.vue?vue&type=template&id=4641f92f&scoped=true"
import script from "./PromotionReportList.vue?vue&type=script&lang=js"
export * from "./PromotionReportList.vue?vue&type=script&lang=js"
import style0 from "./PromotionReportList.vue?vue&type=style&index=0&id=4641f92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641f92f",
  null
  
)

export default component.exports